/**
 * Freelance client work.
 *
 * Two fields carry very different weight and are sourced very differently:
 *
 *   summary        What the site is. Observed from the live site itself, so it
 *                  is checkable by anyone who clicks the link.
 *
 *   contributions  What Rakshan personally built. This is the field an
 *                  interviewer will ask a follow-up question about, so it is
 *                  only ever filled in from what he actually said. An empty
 *                  array renders nothing — the card still shows the client, the
 *                  sector and the link. A thin card is recoverable; a card
 *                  claiming work that cannot be defended in a follow-up is not.
 *
 * THREE ENTRIES BELOW HAVE contributions: []  — lcode, ocean-pearl, aho-cashews.
 * Filling those in is a one-line edit each and nothing else has to change.
 */

export const freelanceWork = [
  {
    id: 'gulf-star',
    client: 'Gulf Star Automotive',
    sector: 'Automotive export · Dubai',
    url: 'https://gulfstarcars.com/en',
    domain: 'gulfstarcars.com',
    status: 'live',
    summary:
      'Vehicle export platform listing Dubai stock for buyers across 100+ countries, with enquiries routed over email, phone and WhatsApp.',
    contributions: [
      'Multi-language support across the site',
      'Transactional mail service for enquiries',
      'On-page SEO and search ranking',
      'Landing page hero and supporting sections',
    ],
  },
  {
    id: 'brokr',
    client: 'Brokr',
    sector: 'PropTech · India',
    url: 'https://www.brokr.in/',
    domain: 'brokr.in',
    status: 'live',
    summary:
      'Verified real-estate marketplace where each listing clears document, ownership and site checks before it is published.',
    contributions: [
      'QR code scanning for lead generation',
      'User behaviour tracking across the lead funnel',
    ],
  },
  {
    id: 'lcode',
    client: 'LCode Technologies',
    sector: 'Enterprise fintech · India',
    url: 'https://www.lcodetechnologies.com/',
    domain: 'lcodetechnologies.com',
    status: 'live',
    summary:
      'Site for a digital banking vendor whose UPI switch, core banking and trustee suites run inside 75+ banks and financial institutions.',
    contributions: [],
  },
  {
    id: 'ocean-pearl',
    client: 'The Ocean Pearl',
    sector: 'Hospitality · India',
    url: 'https://fat-fox-com.vercel.app/',
    domain: 'fat-fox-com.vercel.app',
    // The client's production site is theoceanpearl.in, which is an older
    // build with none of this on it. Calling this "live" would be a claim the
    // link itself disproves, so it is labelled for what it is.
    status: 'preview',
    summary:
      'Booking front end for a 15-property hotel group: property pages, date and room search, and a direct-booking loyalty tier.',
    contributions: [],
  },
  {
    id: 'aho-cashews',
    client: 'Aho Cashews',
    sector: 'D2C food brand · Mangaluru',
    url: 'https://www.ahocashews.in/',
    domain: 'ahocashews.in',
    status: 'live',
    summary:
      'Brand and product site for a roasted cashew maker, running a contact-led ordering model rather than a checkout.',
    contributions: [],
  },
];

export default freelanceWork;
